import React from "react";
import PropTypes from "prop-types";
import lodash from "lodash";

import HeadNav from "./HeadNav";
import Employee from "./Employee";

class Employees extends React.Component {
  state = { currentSkillIndex: 0 };

  get currentSkill() {
    const { currentSkillIndex } = this.state;
    const { skills } = this.props;

    return skills[currentSkillIndex];
  }

  get allowPreviousSkill() {
    const { currentSkillIndex } = this.state;
    return currentSkillIndex > 0;
  }

  get allowNextSkill() {
    const { currentSkillIndex } = this.state;
    const { skills } = this.props;

    return currentSkillIndex < (skills.length - 1);
  }

  goPreviousSkill = () => {
    if (!this.allowPreviousSkill) { return; }

    const { currentSkillIndex } = this.state;
    this.setState({ currentSkillIndex: currentSkillIndex - 1 });
  };

  goNextSkill = () => {
    if (!this.allowNextSkill) { return; }

    const { currentSkillIndex } = this.state;
    this.setState({ currentSkillIndex: currentSkillIndex + 1 });
  };

  render() {
    const {
      isAdmin,
      skills,
      employees,
      employeesSkills,
      inServiceUsers,
      onUpdateSkill,
      onCheckAll,
      currentUser
    } = this.props;

    return (
      <div>
        <HeadNav
          allowPreviousSkill={this.allowPreviousSkill}
          allowNextSkill={this.allowNextSkill}
          currentSkill={this.currentSkill && this.currentSkill.name}
          onGoPreviousSkill={this.goPreviousSkill}
          onGoNextSkill={this.goNextSkill}
        />
        <br/>

        <table style={{ width: "100%" }}>
          <tbody>
          {employees.map(employee => {
            if(employee.id == currentUser.id || isAdmin)
              return(
                <Employee
                key={employee.id}
                isAdmin={isAdmin}
                employee={employee}
                employeesSkills={employeesSkills}
                skill={this.currentSkill}
                skills={skills}
                inServiceUser={lodash.find(inServiceUsers, { user_id: employee.id })}
                onUpdate={onUpdateSkill}
                onCheckAll={onCheckAll}
              />
            )}
          )}
          </tbody>
        </table>

        <div>
          <button
            className="btn btn-indigo btn-raised btn-block"
            disabled={!this.allowNextSkill}
            onClick={this.goNextSkill}
          >
            Next Skill
          </button>
          <button
            className="btn btn-indigo btn-raised btn-block"
            disabled={!this.allowPreviousSkill}
            onClick={this.goPreviousSkill}
          >
            Previous Skill
          </button>
        </div>
      </div>
    );
  }
}

Employees.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  defUsers: PropTypes.array.isRequired,
  employees: PropTypes.array.isRequired,
  employeesSkills: PropTypes.array.isRequired,
  inServiceUsers: PropTypes.array.isRequired,
  onUpdateSkill: PropTypes.func,
  onCheckAll: PropTypes.func.isRequired
};

export default Employees;
